<div class="row">
    <div class="col-12">
      <ngx-loading [show]="loadingIndicator" ></ngx-loading>
  
      <div class="row col-md-12">
        <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)">
          <option value="today">Today</option>
          <option value="weekly">This Week</option>
          <option value="monthly">This Month</option>
          <option value="quarterly">This Quarter</option>
          <option value="yearly">This Year</option>
        </select>
      </div>
      <br /><br />
  
      <div class="row">
        <!-- DRIVER TEST GRAPH -->
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="w-100 h-300p">
            <p>Driver Tests:</p>
            <div class="row" *ngIf="isDriverTestsEmpty()">
              <div class="col-12">
                <div class="alert alert-gray  fade show" role="alert">
                  <strong><i class="fa fa-lg fa-info-circle"></i></strong>No Driver Tests on Record
                </div>
              </div>
            </div>
            <ngx-charts-pie-chart 
              *ngIf="currentDriverChartData"
              [scheme]="colorScheme" [results]="currentDriverChartData"
              [explodeSlices]="explodeSlices" [labels]="showLabels" [doughnut]="doughnut" [gradient]="gradient"
              (select)="onSelect($event)">
            </ngx-charts-pie-chart>
          </div>
        </div> <!-- END OF DRIVER TEST GRAPH -->
            
        <!-- VEHICLE CHECKS GRAPH -->
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="w-100 h-300p">
            <p>Vehicle Checks:</p>
            <div class="row" *ngIf="isVehicleTestsEmpty()">
              <div class="col-md-12">
                <div class="alert alert-gray  fade show" role="alert">
                  <strong><i class="fa fa-lg fa-info-circle"></i>
                  </strong>No Vehicle Tests on Record
                </div>
              </div>
            </div>
            <ngx-charts-pie-chart 
              *ngIf="currentVehicleChartData"    
              [scheme]="colorScheme" [results]="currentVehicleChartData" [explodeSlices]="explodeSlices"
              [labels]="showLabels" [doughnut]="doughnut" [gradient]="gradient" (select)="onSelect($event)" >
            </ngx-charts-pie-chart>
          </div>
        </div> <!-- END OF VEHICLE CHECKS GRAPH -->
  
        <!-- OTHER GRAPH -->
        <div class="col-lg-4 col-md-12 col-sm-12">
          <div class="w-100 h-300p">
            <div class="w-100 h-300p">
              <ngx-charts-bar-vertical-normalized 
                *ngIf="multi"    
                [scheme]="colorSchemes" [results]="multi" [gradient]="gradient"
                [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [legend]="showLegend"
                [legendTitle]="' '"[showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" (select)="onSelect($event)">
              </ngx-charts-bar-vertical-normalized>
            </div>
          </div>
        </div> <!-- END OF OTHER GRAPH -->
      </div>
  
      <div class="row" >
        <div class="col-md-3">
          <div widget class="card border-0 box-shadow">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0"><b>Driver Tests</b>
  
                <div [hidden]="myDropDown !=='today'" >
                  <div class="card-body pt-0 widget-body"><br />
                    <font size="2">Today</font>
                    <ul class="list-group">
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small>Total</small>
                        <span class="badge badge-pill badge-default">{{driverTests.daily.total}}</span>
                      </li>
  
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Passed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.daily.passed}} ({{driverTests.daily.passed_percentage}}%)</span>
                      </li>
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Failed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.daily.failed}} ({{driverTests.daily.failed_percentage}}%)</span>
                      </li>
                    </ul>
                  </div> 
                </div>
  
                <div [hidden]="myDropDown !=='weekly'">
                  <div class="card-body pt-0 widget-body"><br />
                    <font size="2">This Week</font>
                    <ul class="list-group">
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small>Total</small>
                        <span class="badge badge-pill badge-default">{{driverTests.weekly.total}}</span>
                      </li>
                    
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Passed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.weekly.passed}}
                          ({{driverTests.weekly.passed_percentage}}%)</span>
                      </li>
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Failed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.weekly.failed}}
                          ({{driverTests.weekly.failed_percentage}}%)</span>
                      </li>
                    </ul>
                  </div>
                </div>
  
                <div [hidden]="myDropDown !=='monthly'">
                  <div class="card-body pt-0 widget-body"><br />
                    <font size="2">This Month</font>
                    <ul class="list-group">
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small>Total</small>
                        <span class="badge badge-pill badge-default">{{driverTests.monthly.total}}</span>
                      </li>
                    
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Passed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.monthly.passed}}
                          ({{driverTests.monthly.passed_percentage}}%)</span>
                      </li>
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Failed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.monthly.failed}}
                          ({{driverTests.monthly.failed_percentage}}%)</span>
                      </li>
                    </ul>
                  </div>
                </div>
  
                <div [hidden]="myDropDown !=='quarterly'">
                  <div class="card-body pt-0 widget-body"><br />
                    <font size="2">This Quarter</font>
                    <ul class="list-group">
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small>Total</small>
                        <span class="badge badge-pill badge-default">{{driverTests.quarterly.total}}</span>
                      </li>
                    
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Passed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.quarterly.passed}}
                          ({{driverTests.quarterly.passed_percentage}}%)</span>
                      </li>
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Failed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.quarterly.failed}}
                          ({{driverTests.quarterly.failed_percentage}}%)</span>
                      </li>
                    </ul>
                  </div> 
                </div>
  
                <div [hidden]="myDropDown !=='yearly'">
                  <div class="card-body pt-0 widget-body"> <br />
                    <font size="2">This Year</font>
                    <ul class="list-group">
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small>Total</small>
                        <span class="badge badge-pill badge-default">{{driverTests.yearly.total}}</span>
                      </li>
                    
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Passed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.yearly.passed}}
                          ({{driverTests.yearly.passed_percentage}}%)</span>
                      </li>
                      <li class="list-group-item justify-content-between" *ngIf="driverTests">
                        <small> Failed</small>
                        <span class="badge badge-pill badge-default">{{driverTests.yearly.failed}}
                          ({{driverTests.yearly.failed_percentage}}%)</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </h6>
            </div>
          </div>
        </div>
  
        <div class="col-md-3">
          <div widget class="card border-0 box-shadow">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0"><b>Vehicle Checks</b> </h6>
              
            </div>
            <div class="card-body pt-0 widget-body"> <br />
              <div [hidden]="myDropDown !=='yearly'">
                <font size="2">This Year</font>
                <ul class="list-group">
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small>Total</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.yearly.total}}</span>
                  </li>
                
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Passed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.yearly.passed}}
                      ({{vehicleTests.yearly.passed_percentage}}%)</span>
                  </li>
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Failed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.yearly.failed}}
                      ({{vehicleTests.yearly.failed_percentage}}%)</span>
                  </li>
                </ul><br>
              </div>
  
              <div [hidden]="myDropDown !=='quarterly'">
                <font size="2">Quarterly</font>
                <ul class="list-group">
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small>Total</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.quarterly.total}}</span>
                  </li>
                
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Passed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.quarterly.passed}}
                      ({{vehicleTests.quarterly.passed_percentage}}%)</span>
                  </li>
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Failed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.quarterly.failed}}
                      ({{vehicleTests.quarterly.failed_percentage}}%)</span>
                  </li>
                
                </ul><br>        
              </div>
  
              <div [hidden]="myDropDown !=='monthly'">
                <font size="2">This Month</font>
                <ul class="list-group">
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small>Total</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.monthly.total}}</span>
                  </li>
                
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Passed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.monthly.passed}}
                      ({{vehicleTests.monthly.passed_percentage}}%)</span>
                  </li>
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Failed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.monthly.failed}}
                      ({{vehicleTests.monthly.failed_percentage}}%)</span>
                  </li>
                </ul><br>
              </div>
  
              <div [hidden]="myDropDown !=='weekly'">
                <font size="2">This Week</font>
                <ul class="list-group">
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small>Total</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.weekly.total}}</span>
                  </li>
                
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Passed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.weekly.passed}}
                      ({{vehicleTests.weekly.passed_percentage}}%)</span>
                  </li>
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Failed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.weekly.failed}}
                      ({{vehicleTests.weekly.failed_percentage}}%)</span>
                  </li>
                </ul><br>
              </div>
  
              <div [hidden]="myDropDown !=='today'">
                <font size="2">Today</font>
                <ul class="list-group">
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small>Total</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.daily.total}}</span>
                  </li>
                
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Passed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.daily.passed}}
                      ({{vehicleTests.daily.passed_percentage}}%)</span>
                  </li>
                  <li class="list-group-item justify-content-between" *ngIf="vehicleTests">
                    <small> Failed</small>
                    <span class="badge badge-pill badge-default">{{vehicleTests.daily.failed}}
                      ({{vehicleTests.daily.failed_percentage}}%)</span>
                  </li>
                
                </ul><br>
              </div>
  
            </div>
          </div>
        </div>
  
        <div class="col-md-3">
          <div widget class="card border-0 box-shadow" *ngIf="fleetMaintenance">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0" style="text-align: center"><b>Fleet Maintenance</b></h6>
            </div>
            <div class="card-body pt-0 widget-body"> <br />
              <ul class="list-group">
                <li class="list-group-item justify-content-between">
                <small> OK</small>
                  <span class="badge badge-pill badge-default">{{fleetMaintenance.ok}} ({{fleetMaintenance.ok_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                  <small> Low</small>
                  <span class="badge badge-pill badge-default">{{fleetMaintenance.low}} ({{fleetMaintenance.low_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                  <small> Moderate</small>
                  <span class="badge badge-pill badge-default">{{fleetMaintenance.moderate}} ({{fleetMaintenance.moderate_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small> Serious</small>
                  <span class="badge badge-pill badge-default">{{fleetMaintenance.serious}} ({{fleetMaintenance.serious_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                  <small> Total Fleet</small>
                  <span class="badge badge-pill badge-default">{{fleetMaintenance.total}}</span>
                </li>
              </ul>
            </div>
          </div><br>
  
          <div widget class="card border-0 box-shadow" *ngIf="regoRegistrations">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0" style="text-align: center"><b>Registration</b></h6>
            </div>
            <div class="card-body pt-0 widget-body"> <br />
              <ul class="list-group">
                <li class="list-group-item justify-content-between">
                <small> Current</small>
                  <span class="badge badge-pill badge-default">{{regoRegistrations.current}} ({{regoRegistrations.current_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small>  Expired</small>
                  <span class="badge badge-pill badge-default">{{regoRegistrations.expired}} ({{regoRegistrations.expired_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                  <small> Expiring in 30 days</small>
                  <span class="badge badge-pill badge-default">{{regoRegistrations.expiring}} ({{regoRegistrations.expiring_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small>  Total Fleet</small>
                  <span class="badge badge-pill badge-default">{{regoRegistrations.total}}</span>
                </li>
  
              </ul>
            </div>
          </div>
        </div>
  
        <div class="col-md-3">
          <div widget class="card border-0 box-shadow" *ngIf="driverIncidents">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0" style="text-align: center"><b>Driver Incidents</b></h6>
            </div>
            <div class="card-body pt-0 widget-body"> <br />
                <ul class="list-group">
                  <li class="list-group-item justify-content-between">
                  <small>Negligible or No Incidents</small>
                    <span class="badge badge-pill badge-default">{{driverIncidents.ok}} ({{driverIncidents.ok_percentage}}%)</span>
                  </li>
  
                  <li class="list-group-item justify-content-between">
                    <small>Low</small>
                    <span class="badge badge-pill badge-default">{{driverIncidents.low}} ({{driverIncidents.low_percentage}}%)</span>
                  </li>
  
                  <li class="list-group-item justify-content-between">
                  <small> Moderate</small>
                    <span class="badge badge-pill badge-default">{{driverIncidents.moderate}} ({{driverIncidents.moderate_percentage}}%)</span>
                  </li>
  
                  <li class="list-group-item justify-content-between">
                  <small> Serious</small>
                    <span class="badge badge-pill badge-default">{{driverIncidents.serious}} ({{driverIncidents.serious_percentage}}%)</span>
                  </li>
  
                  <li class="list-group-item justify-content-between">
                  <small> Total Drivers</small>
                    <span class="badge badge-pill badge-default">{{driverIncidents.total}}</span>
                  </li>
                </ul>
            </div>
          </div><br>
  
          <div widget class="card border-0 box-shadow" *ngIf="driverLicences">
            <div class="card-header transparent border-0 text-muted">
              <h6 class="mb-0" style="text-align: center"><b>Driver Licences</b></h6>
            </div>
  
            <div class="card-body pt-0 widget-body"> <br />
              <ul class="list-group">
                <li class="list-group-item justify-content-between">
                <small> Current</small>
                  <span class="badge badge-pill badge-default">{{driverLicences.current}} ({{driverLicences.current_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small> Expired</small>
                  <span class="badge badge-pill badge-default">{{driverLicences.expired}} ({{driverLicences.expired_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small> Expiring in 30 days</small>
                  <span class="badge badge-pill badge-default">{{driverLicences.expiring}} ({{driverLicences.expiring_percentage}}%)</span>
                </li>
  
                <li class="list-group-item justify-content-between">
                <small>Total Drivers</small>
                  <span class="badge badge-pill badge-default">{{driverLicences.total}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  